// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const idno: CountryValidator<"MD"> = createValidator(
  "md.idno",
  123,
);

export default idno;
export const compact = idno.compact;
export const format = idno.format;
export const validate = idno.validate;
